import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import theme from '~/constants/theme';
import { useDirection } from '~/hooks/i18nHooks';
import { ApplicationIcon, ArrowRightIcon, ContractIcon, CompletionIcon } from '~/img';
import paths from '~/pages/paths';
import { DirectionProp } from '~/types/Direction';
import { useCardHolderContext } from '~/controllers/cardHolderContext';
import WizardNavStep, { WizardNavStepProps } from './WizardNavStep';

const CardHolderTopNavigation: FC = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const isTablet = useMediaQuery({ maxWidth: theme.breakpoints.lg });
  const dir = useDirection();

  const { stepKey, cardHolderData } = useCardHolderContext();
  // const applicationQuery = useGetApplication();
  // const selectStage = useSelectApplicationStage();
  // const stageStatuses = useApplicationStageStatus();

  const navClickHandler = (routePath: string) => {
    history.push(routePath);
  };

  const isOnboardingCompleted = cardHolderData && cardHolderData.status === 'COMPLETED';

  const navSteps: WizardNavStepProps[] = [
    {
      route: paths.cardHolder.details,
      icon: <ApplicationIcon dir={dir} />,
      name: t('Personal Details'),
      disabled: stepKey === 'personalDetails' || stepKey === 'completion',
      done: stepKey !== 'personalDetails' || isOnboardingCompleted,
      warning: false,
      error: false,
      waiting: false,
      onClick: () => {
        navClickHandler(paths.cardHolder.details);
      },
    },
    {
      route: paths.cardHolder.consent,
      icon: <ContractIcon dir={dir} />,
      name: t('Consent'),
      disabled: stepKey === 'personalDetails' || stepKey === 'completion',
      done: stepKey === 'completion' || isOnboardingCompleted,
      warning: false,
      error: false,
      waiting: false,
      onClick: () => {
        navClickHandler(paths.cardHolder.consent);
      },
    },
    {
      route: paths.cardHolder.completion,
      icon: <CompletionIcon dir={dir} />,
      name: t('Completion'),
      disabled: false, // stepKey !== 'completion',
      done: stepKey === 'completion' || isOnboardingCompleted,
      warning: false,
      error: false,
      waiting: false,
    },
  ];

  return (
    <Container className="WizardTopNavigation" dir={dir}>
      {navSteps.map((item, index, arr) => {
        const isLast = index === arr.length - 1;
        return (
          <div key={item.route} className="WizardTopNavigation-StepContainer">
            <WizardNavStep {...item} />
            {!isLast && <ArrowRightIcon className="WizardTopNavigation-ArrowRightIcon" />}
          </div>
        );
      })}
    </Container>
  );
};

const Container = styled.div<DirectionProp>`
  display: flex;
  align-items: center;
  margin: 0 16px;
  .WizardTopNavigation-StepContainer {
    display: flex;
    align-items: center;
    .WizardTopNavigation-ArrowRightIcon {
      margin: 0 8px;
      color: #e5eaef;
      transform: scaleX(${({ dir }) => (dir === 'ltr' ? 1 : -1)});
    }
  }

  @media (max-width: ${theme.breakpoints.sm}px) {
    margin: 0 12px;
    .WizardTopNavigation-StepContainer {
      .WizardTopNavigation-ArrowRightIcon {
        margin: 0;
        opacity: 0;
        width: 16px;
      }
    }
  }
`;

export default CardHolderTopNavigation;
